import {createApp} from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import '@/font-style/font.css'

// 路由守卫
let registerRouteFresh = true // 定义标识，记录路由是否添加

router.beforeEach(async (to, from, next) => {
    NProgress.start()
    let routeTable = []
    await axios.get(process.env.VUE_APP_SERVER + "/dataprovider/systemdata/route").then(res => {
        routeTable = res.data.content //后台拿到路由
    })
    let arr = [] // 整理后台数据，转换为添加路由的格式
    routeTable.filter((value) => {
        let child = []  // 子路由数据格式处理
        if (value.children && value.children.length) {
            value.children.filter((val) => {
                child.push({
                    name: val.name,
                    path: val.path,
                    component: () => import("@/" + val.component) // 开发中遇到问题，不能使用纯变量，需要字符串拼接才可以，要不然同样的地址报错。
                })
            })
        }
        arr.push({
            name: value.name,
            redirect: value.redirect,
            path: value.path,
            component: () => import("@/" + value.component),
            children: child
        })
    })
    // 如果首次或者刷新界面，next(...to, replace: true)会循环遍历路由，如果to找不到对应的路由那么他会再执行一次beforeEach((to, from, next))直到找到对应的路由，
    // 我们的问题在于页面刷新以后异步获取数据，直接执行next()感觉路由添加了但是在next()之后执行的，所以我们没法导航到相应的界面。这里使用变量registerRouteFresh变量做记录，直到找到相应的路由以后，把值设置为false然后走else执行next(),整个流程就走完了，路由也就添加完了。
    if (registerRouteFresh) {
        arr.forEach((val) => {
            router.addRoute(val)
        })
        next({...to, replace: true})
        registerRouteFresh = false
    }
    // let _this = this;
    // localStorage.setItem("userLocalIP", "10.79.32.20");
    localStorage.setItem("lyqtJwt", "eyJhbGciOiJSUzI1NiJ9.eyJsb2dpbl9uYW1lIjoiVDExNDkyMDgiLCJ1c2VyX2lkIjoidmIyZjEzZ2xydDZrOXVzaXA4MzJ4MmN6Iiwic2NvcGUiOlsib3BlbmlkIl0sIm9yZ2FuaXphdGlvbiI6Ik9SR0FDUTExMDAxMzI5NSIsImlzcyI6ImEzNmMzMDQ5YjM2MjQ5YTNjOWY4ODkxY2IxMjcyNDNjIiwiZXhwIjoxNzA2MDE0ODI1LCJkaXNwbGF5X25hbWUiOiLpnI3pgLjosaoiLCJyZWdpb24iOiJDUSIsImlhdCI6MTcwNTk3MTYyNX0.kiz0wC0cNIHWk2OeUn2zGbYTDABwLlnXeCfXQRxtp2_JcI7cgoyr1g7j1xWvf1iuo2wsxHwnPldzA_oCFjeh4U0eXWCgSLssvRaL5_fHZf9R8Sf54h7MGIWPLfo6GgrBzWysr_DJz1rQ3fFk4Id99JbCRm3OVOX4Q-PzCxCEyBtnJ4s5ntYYOegc5_wdjrLSCUFYeRHBlNE1Tyrl6tU8tK7pA-RTliF4Yo3MapxsmkMMHOwH1-vqpk-N0OOOheimzBsjCKJxfsc0fddaeNH-ohsY3PKoSIU2xa7s3YespI9xI-43VNWTJbDkJFelaPy2uuhnasYRTjeD4BzzD09aiQ");
    const info = {
        user_id: "vb2f13glrt6k9usip832x2cz",
        displayName: "霍逸豪",
        loginName: "T1149208",
        accountId: null,
        belongOrgId: "ORGACQ110013295",
        belongOrgName: "北京金阳普泰石油技术股份有限公司",
        contact: "17629246020",
        email: "tlm-dz@cnpc.com.cn",
        positionList: null,
        employeeId: "vb2f13glrt6k9usip832x2cz"
    };
    localStorage.setItem('lyqtUserInfo', JSON.stringify(info));
    if (to.path == '/login') {
        next();
    } else {
        let jwtSession = localStorage.getItem("licUserJwt")
        let userCodeSession = localStorage.getItem("licUserCode")
        if(jwtSession == null || jwtSession.length == 0 || userCodeSession == null || userCodeSession.length == 0) {
            next({path: '/login'})
            return;
        }
        await axios.post(process.env.VUE_APP_SERVER + "/dataprovider/systemdata/checkJwt", {
            userCode: userCodeSession,
            userJwt: jwtSession
        }).then(res => {
            console.log(res.data)
            if (res.data.success == true) {
                next()
            }
            else{
                localStorage.removeItem("licUserJwt");
                localStorage.removeItem("licUserCode");
                next({path: '/login'})
            }
        }).catch(err => {
            console.log(err)
        })
    }
    // if (process.env.NODE_ENV === "development") {
    //     localStorage.setItem("lyqtJwt", "eyJhbGciOiJSUzI1NiJ9.eyJsb2dpbl9uYW1lIjoiMDA2OTk4OTMiLCJ1c2VyX2lkIjoiMWNwM2RsYWQ4cm9hNTRsc29jeWl0MTI2Iiwib3JnYW5pemF0aW9uIjoiT1JHQVRMMTEwMDA1NDY2IiwiaXNzIjoiYTM2YzMwNDliMzYyNDlhM2M5Zjg4OTFjYjEyNzI0M2MiLCJkaXNwbGF5X25hbWUiOiLmnY7lrrbph5EiLCJyZWdpb24iOiJUTCIsImlhdCI6MTY0NzMzMzE0NCwiZXhwIjoxNjQ5OTI1MTQ0fQ.ktKBX1AbEAabTymY6rkIDqkfQXezyvRc5OjanvZv9w8BoILpc5-Y1BcvSuKDM4wqfxcGx9IDMZRdzUWbnzj9sFqGsWDuXjYQUBZlfNlB3uZn7fonDC4Bpt65G65yHBwdhZWcb-D2ymxHz9lkYXbjbWJu1D8JhCa4dzqTmv4o2cYBI2Q9UfQPYiGRw7zZKhpQ6E0c52KRK_c1dEsYIfNA_7PtXNqQOa2UYAqri6GNf61ujnn5DOKDxuiLRUtfJQdb9YP8do5l2AnCq5qtPKNvz7M1xVK47xtZMfUJLFkWJXB8e1B3SbmilBn_W_IlU-OK8YkiJWsMKSwEWaxuSKdApg");
    //     next()
    // }
    // else
    // {

    // let jwtSession = "eyJhbGciOiJSUzI1NiJ9.eyJsb2dpbl9uYW1lIjoiMDA2OTk4OTMiLCJ1c2VyX2lkIjoiMWNwM2RsYWQ4cm9hNTRsc29jeWl0MTI2Iiwib3JnYW5pemF0aW9uIjoiT1JHQVRMMTEwMDA1NDY2IiwiaXNzIjoiYTM2YzMwNDliMzYyNDlhM2M5Zjg4OTFjYjEyNzI0M2MiLCJkaXNwbGF5X25hbWUiOiLmnY7lrrbph5EiLCJyZWdpb24iOiJUTCIsImlhdCI6MTY0NzMzMzE0NCwiZXhwIjoxNjQ5OTI1MTQ0fQ.ktKBX1AbEAabTymY6rkIDqkfQXezyvRc5OjanvZv9w8BoILpc5-Y1BcvSuKDM4wqfxcGx9IDMZRdzUWbnzj9sFqGsWDuXjYQUBZlfNlB3uZn7fonDC4Bpt65G65yHBwdhZWcb-D2ymxHz9lkYXbjbWJu1D8JhCa4dzqTmv4o2cYBI2Q9UfQPYiGRw7zZKhpQ6E0c52KRK_c1dEsYIfNA_7PtXNqQOa2UYAqri6GNf61ujnn5DOKDxuiLRUtfJQdb9YP8do5l2AnCq5qtPKNvz7M1xVK47xtZMfUJLFkWJXB8e1B3SbmilBn_W_IlU-OK8YkiJWsMKSwEWaxuSKdApg";
    // localStorage.setItem("lyqtJwt", jwtSession);
    // console.log("jwt:",jwtSession);
    // console.log("to.path", to.path);
    // console.log("sessionJwt", jwtSession);
    // if (jwtSession == null) jwtSession = {};
    // console.log("jwt2:",jwtSession);
    // }
})

router.afterEach(() => {
    NProgress.done()
})



import ElementPlus from 'element-plus'
import 'element-plus/lib/theme-chalk/index.css'
import vueRightMenu from "vue-right-click-menu-next"
import axios from "axios";
import zhCn from 'element-plus/lib/locale/lang/zh-cn';
import '@/assets/iconfont/iconfont.css' // permission control
import dialogDrag from './dialogDrag'
// import VueKonva from 'vue-konva'
const app = createApp(App)
app.use(ElementPlus, {
    locale: zhCn,
})
app.use(vueRightMenu)
app.use(dialogDrag)
app.use(store)
app.use(router)
// app.use(VueKonva)
app.mount('#app')
console.log('当前环境数据地址：', process.env);

// import store from'./store/store'
//定义全局变量
class Vue {
    constructor() {
    }
}

new Vue({
    el: '#app',
    router,
    store,
    template: '<App/>',
    components: {App},
    data: function () {
        return {
            wellData: null
        }
    },
});

